export default __webpack_public_path__ + "static/media/prm-phone.42be356f.png";